import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FaChartBar,
  FaChartPie,
  FaUsers,
  FaBoxOpen,
  FaCalendarAlt,
  FaCogs,
  FaBell,
  FaTachometerAlt,
  FaFileAlt,
  FaComments,
  FaTimes,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import NavButton from "./NavButton";
import SubMenu from "./SubMenu";
import Chat from "../../pages/Chat/Chat";

export default function MenuNavegacao({ isActive }) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const [chatAberto, setChatAberto] = useState(false);

  const toggleSubMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  return (
    <>
      {/* MENU SUPERIOR */}
      <nav
        className="bg-[#f95000] shadow-2xl px-6 py-0.5 items-center gap-4 text-white hidden md:flex fixed top-[80px] left-0 w-full z-50 text-sm backdrop-blur-sm border-b border-white/10 font-medium tracking-wide font-roboto"
        style={{ fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"' }}
      >
        <NavButton
          to="/painel/dashboard"
          icon={FaChartPie}
          label="Dashboard"
          isActive={isActive("/painel/dashboard")}
        />

        {/* MENU CADASTROS — agora com Produtos incluso */}
        <SubMenu
          open={openMenu === "cadastros"}
          toggle={() => toggleSubMenu("cadastros")}
          icon={FaUsers}
          label="Cadastros"
          items={[
            { to: "/painel/clientes", label: "Clientes", icon: FaUsers },
            { to: "/painel/produtos", label: "Produtos", icon: FaBoxOpen }, // <-- ADICIONADO AQUI
          ]}
        />

        <SubMenu
          open={openMenu === "chamados"}
          toggle={() => toggleSubMenu("chamados")}
          icon={FaChartBar}
          label="Chamados"
          items={[
            {
              to: "/painel/painel-chamados",
              label: "Painel de Chamados",
              icon: FaTachometerAlt,
            },
            {
              to: "/painel/tipos-servico",
              label: "Tipos de Serviços",
              icon: FaCogs,
            },
          ]}
        />

        <NavButton
          to="/painel/agendamentos"
          icon={FaCalendarAlt}
          label="Agendamentos"
          isActive={isActive("/painel/agendamentos")}
        />

        {/* 🚫 REMOVIDO DO MENU PRINCIPAL
        <NavButton
          to="/painel/produtos"
          icon={FaBoxOpen}
          label="Produtos"
          isActive={isActive("/painel/produtos")}
        />
        */}

        <SubMenu
          open={openMenu === "relatorios"}
          toggle={() => toggleSubMenu("relatorios")}
          icon={FaFileAlt}
          label="Relatórios"
          items={[
            {
              to: "/painel/relatorios-chamados",
              label: "Relatórios de Chamados",
              icon: FaChartBar,
            },
          ]}
        />

        <div className="ml-auto flex items-center gap-2 text-white text-sm font-medium tracking-wide">
          <FaBell className="animate-pulse" />
          <span>Versão 1.0.21</span>
        </div>
      </nav>

      {/* BOTÃO FIXO – CHAT INTERNO */}
      <div
        className="fixed bottom-6 right-6 bg-[#f95000] text-white flex items-center gap-3 px-5 py-3 rounded-full shadow-lg cursor-pointer hover:bg-[#ff6b1a] transition-all duration-300 z-[9999]"
        style={{ fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"' }}
        onClick={() => setChatAberto(true)}
      >
        <FaComments size={20} />
        <span className="font-medium text-base tracking-wide">Chat Interno</span>
      </div>

      {/* MODAL DO CHAT */}
      <AnimatePresence>
        {chatAberto && (
          <motion.div
            className="fixed inset-0 bg-black/60 flex justify-center items-center z-[10000]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-lg shadow-2xl w-[95%] max-w-[1100px] h-[80vh] flex flex-col relative overflow-hidden border border-gray-200"
              initial={{ scale: 0.9, y: 40 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 40 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              {/* Cabeçalho */}
              <div className="flex justify-between items-center p-3 bg-[#f95000] text-white">
                <h2 className="text-lg font-semibold">Chat Interno 💬</h2>
                <button
                  onClick={() => setChatAberto(false)}
                  className="hover:text-gray-200 transition"
                >
                  <FaTimes size={20} />
                </button>
              </div>

              {/* Conteúdo do Chat */}
              <div className="flex-1 overflow-y-auto p-4 bg-white">
                <Chat />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
